<template>
  <a-drawer
    :title="detail ? '编辑内容' : '新建内容'"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <!-- form -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 内容标题 -->
      <a-form-item
        label="内容标题"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
        />
      </a-form-item>
      
      <!-- 内容ID -->
      <a-form-item
        label="内容ID"
        name="content_id"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.content_id"
          placeholder="请输入"
        />
      </a-form-item>
      
      <!-- 字幕语种 -->
      <a-form-item
        label="字幕语种"
        name="lang_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.lang_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      
      <!-- 公开日期 -->
      <a-form-item
        label="公开日期"
        name="publish_date"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-date-picker
          v-model:value="formState.publish_date"
          placeholder="请选择"
          style="width: 100%"
        />
      </a-form-item>
      
      <!-- 发布账号 -->
      <a-form-item
        label="发布账号"
        name="account_id"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          v-model:value="formState.account_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in publishingAccountList"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref, nextTick } from 'vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { MediaTypes, AudienceTypes } from '@/utils/constantList'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
// 引入 API
import { ytContentSave, langSearchList, accountAll } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// form
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 语种列表
let languages= ref([])
// 发布账号列表
let publishingAccountList= ref([])
// 修改对象
let detail = ref(null)
// 剧详情
let dramaDetail = ref(null)

// 表单参数
const formState = ref({
  // 剧名
  name: undefined,
  // 视频语种（语言id）
  lang_id: undefined,
  // 内容ID
  content_id: undefined,
  // 公开日期（YYYY-MM-DD）
  publish_date: undefined,
  // 发布账号id
  account_id: undefined
})

// 显示弹窗
function showDrawer(record, drama) {
  visible.value = true
  detail.value = record
  dramaDetail.value = drama

  // 如果有记录数据，则为编辑模式，填充表单
  if (record && record.id) {
    nextTick(() => {
      formState.value = {
        name: record.name,
        lang_id: record.lang_id,
        content_id: record.content_id,
        publish_date: record.publish_date ? dayjs(record.publish_date) : undefined,
        account_id: record.account_id
      }
    })
  } else {
    // 新建模式，重置表单
    nextTick(() => {
      formState.value = {
        name: undefined,
        lang_id: undefined,
        content_id: undefined,
        publish_date: undefined,
        account_id: undefined
      }
    })
  }
  // 获取选择项
  getSelectList()
}

// 获取选择项
function getSelectList() {
  // 语种列表
  langSearchList().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      languages.value = data
    }
  })
  // 发布账号列表
  accountAll().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      publishingAccountList.value = data
    }
  })
}

// 关闭弹窗
function onClose() {
  visible.value = false
  // 重置表单
  RefForm.value?.resetFields()
  formState.value = {
    name: undefined,
    lang_id: undefined,
    content_id: undefined,
    publish_date: undefined,
    account_id: undefined
  }
  detail.value = null
  dramaDetail.value = null
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((res) => {
    // 上传数据
    const params = {
      id: detail.value && detail.value.id,
      yt_drama_id: dramaDetail.value.id,
      ...res,
      // 格式化时间，将dayjs对象转换为YYYY-MM-DD字符串
      publish_date: res.publish_date ? dayjs(res.publish_date).format('YYYY-MM-DD') : undefined
    }
    isLoading.value = true
    // TODO: 替换为实际的API调用
    ytContentSave(params).then((res) => {
      isLoading.value = false
      if (res.code === 0) {
        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message)
      }
    }).catch(() => {
      isLoading.value = false
      message.error('保存失败')
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 暴露方法给父组件
defineExpose({
  showDrawer
})
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>
